import { TYPO } from "styles/Typo";
import { routeToStockDetailPage } from "utils/routing";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { Forward } from "components/common/Icons";
import { useTabTracking } from "lib/analytics/react/hooks";

function DetailFundamentalSummary({
  data,
  ticker,
}: {
  data: any;
  ticker: string;
}) {
  const router = useRouter();
  const { t } = useTranslation("detail");
  const { trackClick } = useTabTracking("stock_tab_click", [
    "overview",
    "score",
    "fund",
    "feed",
  ]);
  const filteredMomentumExplainData = data?.filter(
    (item: any) => !item?.keyword?.includes("없") && item?.description
  );
  const upData = filteredMomentumExplainData?.filter(
    (item: any) => item?.momentum_type === "up"
  )?.[0];
  const downData = filteredMomentumExplainData?.filter(
    (item: any) => item?.momentum_type === "down"
  )?.[0];

  // Recoil 로딩 게이트 제거 — aiData 는 GSSP 로 이미 있으므로 SSR 본문에 바로 출력
  if (!upData || !downData) return null;
  return (
    <div className="pt-[30px] px-6 flex flex-col gap-4 ">
      <p className={`${TYPO.TYPO4_SB} text-gray90`}>{t("fundamentals")}</p>
      <div className="rounded-[14px] overflow-hidden flex flex-col bg-gray5 border border-hairline">
        <div className=" bg-white">
          <div className=" px-4 py-3 flex items-center gap-3 border-b border-hairline">
            <p
              className={`${TYPO.TYPO8_MD} text-green50 bg-green5 w-[30px] h-[30px] rounded-[10px] flex items-center justify-center shrink-0 whitespace-nowrap`}
            >
              {t("positive")}
            </p>
            <div>
              <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>
                {upData?.keyword}
              </p>
              {upData?.momentum_summary && (
                <p className={`${TYPO.TYPO8_RG} text-gray60`}>
                  {upData.momentum_summary}
                </p>
              )}
              <p className={`${TYPO.TYPO8_RG} text-gray50 line-clamp-1`}>
                {upData?.description}
              </p>
            </div>
          </div>
          <div className=" px-4 py-3 flex items-center gap-3">
            <p
              className={`${TYPO.TYPO8_MD} text-red50 bg-red5 w-[30px] h-[30px] rounded-[10px] flex items-center justify-center shrink-0 whitespace-nowrap`}
            >
              {t("negative")}
            </p>
            <div>
              <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>
                {downData?.keyword}
              </p>
              {downData?.momentum_summary && (
                <p className={`${TYPO.TYPO8_RG} text-gray60`}>
                  {downData.momentum_summary}
                </p>
              )}
              <p className={`${TYPO.TYPO8_RG} text-gray50 line-clamp-1`}>
                {downData?.description}
              </p>
            </div>
          </div>
        </div>
        <div
          data-gtm-id={"sDetail-news-more-button"}
          className="w-full flex items-center justify-center cursor-pointer px-4 py-[10px] gap-1 border-t border-hairlineBorder"
          onClick={() => {
            trackClick("fund", "shortcut", "stock_overview_fundamental");
            routeToStockDetailPage(
              router,
              ticker,
              "push",
              {
                shallow: true,
              },
              "info"
            );
          }}
        >
          <p className={`${TYPO.TYPO7_MD} text-gray80`}>
            {t("viewMore")}
          </p>
          <Forward fill="gray80" width={12} height={12} />
        </div>
      </div>
    </div>
  );
}

export default DetailFundamentalSummary;
